import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SEO_FEATURE_NAME, reducers, StoryblokSeoEffects } from './store';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(SEO_FEATURE_NAME, reducers),
    EffectsModule.forFeature([StoryblokSeoEffects]),
  ],
})
export class StoryblokSeoModule {}
